// Web Audio API sound engine — zero external dependencies
// Works in all modern browsers; fails silently if blocked

let ctx = null;

function getCtx() {
  if (!ctx) ctx = new (window.AudioContext || window.webkitAudioContext)();
  return ctx;
}

function beep({ freq = 440, type = 'sine', duration = 0.15, volume = 0.3, delay = 0 } = {}) {
  try {
    const c = getCtx();
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.connect(gain);
    gain.connect(c.destination);
    osc.type = type;
    osc.frequency.setValueAtTime(freq, c.currentTime + delay);
    gain.gain.setValueAtTime(volume, c.currentTime + delay);
    gain.gain.exponentialRampToValueAtTime(0.001, c.currentTime + delay + duration);
    osc.start(c.currentTime + delay);
    osc.stop(c.currentTime + delay + duration);
  } catch (e) {
    // silently ignore if audio is blocked
  }
}

export function playSound(type) {
  switch (type) {
    case 'correct':
      beep({ freq: 523, type: 'sine', duration: 0.12, volume: 0.25 });
      beep({ freq: 659, type: 'sine', duration: 0.12, volume: 0.25, delay: 0.1 });
      beep({ freq: 784, type: 'sine', duration: 0.18, volume: 0.25, delay: 0.2 });
      break;
    case 'wrong':
      beep({ freq: 220, type: 'sawtooth', duration: 0.2, volume: 0.2 });
      beep({ freq: 180, type: 'sawtooth', duration: 0.25, volume: 0.2, delay: 0.15 });
      break;
    case 'timeout':
      beep({ freq: 330, type: 'square', duration: 0.08, volume: 0.2 });
      beep({ freq: 280, type: 'square', duration: 0.08, volume: 0.2, delay: 0.1 });
      beep({ freq: 220, type: 'square', duration: 0.15, volume: 0.2, delay: 0.2 });
      break;
    case 'complete':
      [0, 0.1, 0.2, 0.35].forEach((d, i) => {
        beep({ freq: [523, 587, 659, 784][i], duration: 0.15, volume: 0.25, delay: d });
      });
      break;
    case 'streak':
      [0, 0.08, 0.16, 0.24, 0.32].forEach((d, i) => {
        beep({ freq: [400, 500, 600, 700, 900][i], type: 'sine', duration: 0.1, volume: 0.2, delay: d });
      });
      break;
    default:
      break;
  }
}